import { Caption } from "@bounce/design-system"
import { useTranslation } from "@bounce/i18n"

import type { NearbyStorageSpot } from "@/libs/bounce/stores/types"

import LuggageIcon from "@bounce/assets/icons/Luggage.svg"

type StoreCardCapacityCaptionProps = Pick<NearbyStorageSpot, "maxCapacity">

export const StoreCardCapacityCaption = ({ maxCapacity }: StoreCardCapacityCaptionProps) => {
  const { t } = useTranslation()

  const capacity = maxCapacity ?? -1
  if (capacity === 0) {
    return null
  }

  return (
    <span className="text-neutral-800">
      <LuggageIcon className="mr-1 inline-block size-4" />
      <Caption>
        {t(
          "cmp.storeCard.maxCapacityCaption",
          "{capacity, plural, =-1 {Unlimited bag capacity} other {Capacity # bags}}",
          {
            capacity,
          },
        )}
      </Caption>
    </span>
  )
}
